module.exports = __webpack_public_path__ + "static/media/car.33d34569.webp";